import { Controller } from "@hotwired/stimulus"
import Rails from '@rails/ujs';

export default class extends Controller {
  connect() {
    const remoteLinks = Array.from(document.querySelectorAll("a[data-remote='true']"))
    remoteLinks.forEach(function(element) {
      const voidUrl = "javascript:void(0);"
      if (element.href == voidUrl || element.className == 'page-link') {
        return;
      }
      element.dataset.url = element.href
      element.href = voidUrl
    })

    Rails.href = function(element) {
      return element.dataset.url || element.href
    }
  }
}
